import { NavbarSearchUI } from './NavbarSearchUI.jsx';
import { HomepageSearchUI } from './HomepageSearchUI.jsx';
import createSearchWidget from './SearchWidget.jsx';

export const NavbarSearchWidget = createSearchWidget(NavbarSearchUI);
export const HomepageSearchWidget = createSearchWidget(HomepageSearchUI);

